import React, { useState } from "react";
import ReactDropdown from "react-dropdown";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { pushNotification } from "utils/notifications";
import {
  OPTIONS_KY,
  OPTIONS_KY_SO_SANH,
  TUY_CHINH,
  KY_LIEN_TRUOC,
} from "./khoangThoiGian";

const customStyles = `
  .khgt-search .Dropdown-menu {
      max-height: 320px;
      overflow-y: auto;
  }
  .khgt-search .Dropdown-option {
      padding: 8px 10px;
      font-size: 13px;
  }
  .khgt-search .Dropdown-option:hover {
      background-color: #e3f2fd;
      color: #007bff;
  }
  .khgt-search .Dropdown-option.is-selected {
      background-color: #007bff;
      color: #fff;
  }
  .khgt-nhom-loc {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 10px;
  }
`;

export const SearchBarKhachHangGiaTang = ({ boLocMacDinh, onApply }) => {
  const [boLoc, setBoLoc] = useState(boLocMacDinh);

  const doiKy = (field) => (option) => {
    setBoLoc((prev) => ({ ...prev, [field]: option.value }));
  };

  const doiNgay = (field) => (date) => {
    setBoLoc((prev) => ({ ...prev, [field]: date }));
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    if (boLoc.ky === TUY_CHINH && (!boLoc.tuNgay || !boLoc.denNgay)) {
      pushNotification("Vui lòng chọn đủ Từ ngày - Đến ngày!", "warning");
      return;
    }
    if (
      boLoc.kySoSanh === TUY_CHINH &&
      (!boLoc.ssTuNgay || !boLoc.ssDenNgay)
    ) {
      pushNotification(
        "Vui lòng chọn đủ khoảng thời gian so sánh!",
        "warning"
      );
      return;
    }

    // Luôn tạo object mới để bấm Tìm kiếm liên tiếp vẫn kích hoạt tải lại
    onApply({ ...boLoc });
  };

  const renderChonNgay = (fieldTu, fieldDen) => (
    <>
      <div className="input-sm-new" style={{ minWidth: "130px" }}>
        <label className="font-color-default font-bold">Từ ngày</label>
        <DateTimePicker
          value={boLoc[fieldTu]}
          onChange={doiNgay(fieldTu)}
          placeholder="Chọn ngày"
        />
      </div>
      <div className="input-sm-new" style={{ minWidth: "130px" }}>
        <label className="font-color-default font-bold">Đến ngày</label>
        <DateTimePicker
          value={boLoc[fieldDen]}
          onChange={doiNgay(fieldDen)}
          placeholder="Chọn ngày"
        />
      </div>
    </>
  );

  return (
    <form onSubmit={handleSubmit} className="khgt-search">
      <style>{customStyles}</style>

      <div className="search-new d-flex flex-row align-items-end justify-content-start flex-wrap">
        <div className="khgt-nhom-loc mr-3">
          <div className="input-sm-new" style={{ minWidth: "200px" }}>
            <label className="font-color-default font-bold">
              Lọc theo thời gian
            </label>
            <ReactDropdown
              options={OPTIONS_KY}
              onChange={doiKy("ky")}
              value={OPTIONS_KY.find((o) => o.value === boLoc.ky)}
              placeholder="Chọn thời gian"
              controlClassName="form-control input-sm"
            />
          </div>
          {boLoc.ky === TUY_CHINH && renderChonNgay("tuNgay", "denNgay")}
        </div>

        <div className="khgt-nhom-loc mr-3">
          <div className="input-sm-new" style={{ minWidth: "200px" }}>
            <label className="font-color-default font-bold">So sánh với</label>
            <ReactDropdown
              options={OPTIONS_KY_SO_SANH}
              onChange={doiKy("kySoSanh")}
              value={OPTIONS_KY_SO_SANH.find(
                (o) => o.value === boLoc.kySoSanh
              )}
              placeholder="Chọn kỳ so sánh"
              controlClassName="form-control input-sm"
            />
          </div>
          {boLoc.kySoSanh === TUY_CHINH &&
            renderChonNgay("ssTuNgay", "ssDenNgay")}
        </div>

        <div className="input-sm-new mt-1">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ paddingTop: "7px" }}
          >
            <i className="la la-search"></i> Tìm kiếm
          </button>
        </div>
      </div>

      {boLoc.kySoSanh === KY_LIEN_TRUOC && (
        <div style={{ fontSize: 12, color: "#858796", paddingLeft: 2 }}>
          (*) Kỳ liền trước được tính tự động theo đúng độ dài khoảng thời gian
          đang lọc.
        </div>
      )}
    </form>
  );
};
